import React from "react";
import classNames from "classnames";

const tabList = [
  {
    name: "regulation",
    title: "Regulasi",
  },
  {
    name: "guiden",
    title: "Panduan PSrE",
  },
  {
    name: "infographic",
    title: "Infografik",
  },
];

const MenuTab = ({ activeTab, handleChangeTab }) => {
  return (
    <div style={{ borderBottom: "1px solid rgba(0,0,0,0.12)" }}>
      <div className="container container-nav">
        <ul
          className="nav nav-pills"
          id="pills-kegiatan-acara-saya"
          role="tablist"
        >
          {tabList.map((e, i) => {
            return (
              <>
                <li
                  className="nav-item"
                  onClick={() => handleChangeTab(e.name)}
                  style={{ cursor: "pointer" }}
                  key={i + e.name}
                >
                  <div
                    className={classNames("nav-link", {
                      active: activeTab === e.name,
                    })}
                    id="pills-acara-tab"
                    data-toggle="pill"
                    role="tab"
                    aria-controls="pills-acara"
                    aria-selected="true"
                  >
                    {e.title}
                  </div>
                </li>
              </>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default MenuTab;
